const replacements: ReadonlyArray<readonly [string, string]> = [
  ["Unvollstaendig", "Unvollständig"], ["unvollstaendig", "unvollständig"],
  ["Vollstaendig", "Vollständig"], ["vollstaendig", "vollständig"],
  ["ZuPruefen", "Zu prüfen"], ["InPruefung", "In Prüfung"],
  ["Wareneingaenge", "Wareneingänge"], ["Massnahmen", "Maßnahmen"], ["massnahmen", "maßnahmen"],
  ["Gross", "Groß"], ["gross", "groß"], ["Kueche", "Küche"], ["kueche", "küche"],
  ["Menues", "Menüs"], ["menues", "menüs"], ["Menue", "Menü"], ["menue", "menü"],
  ["Naehr", "Nähr"], ["naehr", "nähr"], ["Naerwert", "Nährwert"],
  ["Haehn", "Hähn"], ["haehn", "hähn"], ["Aepfel", "Äpfel"], ["aepfel", "äpfel"],
  ["Tuerkei", "Türkei"], ["Gemuese", "Gemüse"], ["gemuese", "gemüse"],
  ["Gefluegel", "Geflügel"], ["gefluegel", "geflügel"], ["Getraenk", "Getränk"], ["getraenk", "getränk"],
  ["Gewuerz", "Gewürz"], ["gewuerz", "gewürz"], ["Kuehl", "Kühl"], ["kuehl", "kühl"],
  ["Oel", "Öl"], ["oel", "öl"], ["Qualitaet", "Qualität"], ["qualitaet", "qualität"],
  ["Geschaeft", "Geschäft"], ["geschaeft", "geschäft"], ["Fuehr", "Führ"], ["fuehr", "führ"],
  ["Prioritaet", "Priorität"], ["prioritaet", "priorität"], ["Aktivitaet", "Aktivität"], ["aktivitaet", "aktivität"],
  ["Krueger", "Krüger"], ["Mueller", "Müller"], ["Koenig", "König"], ["Schaefer", "Schäfer"],
  ["Griess", "Grieß"], ["griess", "grieß"], ["Weiss", "Weiß"], ["weiss", "weiß"],
  ["Heiss", "Heiß"], ["heiss", "heiß"], ["Suess", "Süß"], ["suess", "süß"],
  ["Fuss", "Fuß"], ["fuss", "fuß"], ["Geprueft", "Geprüft"], ["geprueft", "geprüft"],
  ["Pruef", "Prüf"], ["pruef", "prüf"], ["Geaender", "Geänder"], ["geaender", "geänder"],
  ["Aender", "Änder"], ["aender", "änder"], ["Naech", "Näch"], ["naech", "näch"],
  ["Guelt", "Gült"], ["guelt", "gült"], ["Kuendig", "Kündig"], ["kuendig", "kündig"],
  ["Loesch", "Lösch"], ["loesch", "lösch"], ["Bestaet", "Bestät"], ["bestaet", "bestät"],
  ["Schluessel", "Schlüssel"], ["schluessel", "schlüssel"], ["Zurueck", "Zurück"], ["zurueck", "zurück"],
  ["Rueck", "Rück"], ["rueck", "rück"], ["Ueber", "Über"], ["ueber", "über"],
  ["fuer", "für"], ["Fuer", "Für"], ["Stueck", "Stück"], ["stueck", "stück"],
  ["oeffn", "öffn"], ["Oeffn", "Öffn"], ["waehl", "wähl"], ["Waehl", "Wähl"],
  ["verfueg", "verfüg"], ["Verfueg", "Verfüg"], ["ausfuehr", "ausführ"], ["Ausfuehr", "Ausführ"],
  ["unterstuetz", "unterstütz"], ["Unterstuetz", "Unterstütz"], ["Verknuepf", "Verknüpf"], ["verknuepf", "verknüpf"],
  ["Vorgaeng", "Vorgäng"], ["vorgaeng", "vorgäng"], ["erhoeh", "erhöh"], ["Erhoeh", "Erhöh"],
  ["Stoer", "Stör"], ["stoer", "stör"], ["Geraet", "Gerät"], ["geraet", "gerät"],
  ["durchgaeng", "durchgäng"], ["Durchgaeng", "Durchgäng"], ["ausschliess", "ausschließ"], ["Ausschliess", "Ausschließ"],
  ["Strasse", "Straße"], ["strasse", "straße"], ["Groesse", "Größe"], ["groesse", "größe"],
];

const statusLabels: Record<string, string> = {
  FreigabeErforderlich: "Freigabe erforderlich",
  "Freigabe angefordert": "Freigabe angefordert",
  ZuPruefen: "Zu prüfen",
  InPruefung: "In Prüfung",
  Geprueft: "Geprüft",
  Veroeffentlicht: "Veröffentlicht",
  Unvollstaendig: "Unvollständig",
  Teilgeliefert: "Teilgeliefert",
  ZurAbrechnung: "Zur Abrechnung",
  "Zur Abrechnung freigegeben": "Zur Abrechnung freigegeben",
  InBearbeitung: "In Bearbeitung",
  neu: "Neu",
  geaendert: "Geändert",
  uebersprungen: "Übersprungen",
  gesperrt: "Gesperrt",
  Geloest: "Gelöst",
  "Gelöst": "Gelöst",
};

const entityLabels: Record<string, string> = {
  EinkaufBestellung: "Einkaufsbestellung",
  EinkaufBestellungen: "Einkaufsbestellungen",
  FuhrparkService: "Fuhrpark-Service",
  Workorder: "Arbeitsauftrag",
  Workorders: "Arbeitsaufträge",
  WorkorderSteps: "Arbeitsschritte",
  Tickets: "Tickets",
  Ticket: "Ticket",
  Menu: "Menüs",
  MenuPlan: "Speiseplan",
  MenuRezepte: "Menü-Rezepte",
  RezeptArtikel: "Rezept-Zutaten",
  Rezepte: "Rezepte",
  Abrechnungsfall: "Abrechnungsfall",
  Abrechnungsfaelle: "Abrechnungsfälle",
};

export const germanStatusOptions = [
  "Entwurf", "Geprueft", "Veroeffentlicht", "Gesperrt", "FreigabeErforderlich", "Freigabe angefordert", "Freigegeben", "Abgelehnt",
  "Bestellt", "Teilgeliefert", "Geliefert", "Abgerechnet", "Exportiert", "Bezahlt",
  "Neu", "Geplant", "In Bearbeitung", "Offen", "Erledigt", "Aktiv", "Inaktiv",
  "Unvollstaendig", "ZuPruefen", "InPruefung", "neu", "geaendert", "uebersprungen", "gesperrt",
];

export function formatGermanDisplayText(value: string): string {
  return replacements.reduce((text, [source, target]) => text.replaceAll(source, target), value);
}

export function formatGermanStatus(value: unknown): string {
  const key = String(value ?? "").trim();
  if (!key) return "";
  return statusLabels[key] || formatGermanDisplayText(key.replace(/([a-zäöüß])([A-ZÄÖÜ])/g, "$1 $2"));
}

export function formatGermanEntity(value: unknown): string {
  const key = String(value ?? "").trim();
  if (!key) return "";
  return entityLabels[key] || formatGermanLabel(key);
}

export function formatGermanLabel(value: string): string {
  return formatGermanDisplayText(value.replace(/([a-zäöüß])([A-ZÄÖÜ])/g, "$1 $2"));
}
